// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"e4a01211","693":"2620a50b","845":"a37f9888"}[chunkId] + ".chunk.css";
};